// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host flw-banner {
  margin-top: var(--space-md);
  margin-bottom: var(--space-md);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/info-user-temporal-card/info-user-temporal-card.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;EACA,8BAAA;AAAR","sourcesContent":[":host {\r\n    flw-banner {\r\n        margin-top: var(--space-md);\r\n        margin-bottom: var(--space-md);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
